import React from 'react';
import PropTypes from 'prop-types';

const formatHeight = height => {
  const feet = Math.floor(height / 12);
  const inches = height % 12;
  return `${feet}'${inches}"`;
};

const PlayerViewSummary = ({ player }) => {
  const { stats, teams, leagues } = player;
  const career = stats && stats[stats.length - 1];
  const teamSummary = teams.map(team => team.name).join(', ');
  const leagueSummary = leagues.map(league => league.name).join(', ');

  return (
    <div className="s-player-view__summary">
      <div className="s-player-view__summary--image">
        <img src={player.image} alt={`Player - ${player.normalized}`} />
      </div>
      <div className="s-player-view__summary--text">
        <h1>{player.normalized}</h1>
        <h3>
          <span>
            <em>aka.</em> {player.name}
          </span>
          <span>#{player.jersey}</span>
          {player.height > 0 && <span>{formatHeight(player.height)}</span>}
          {player.position !== '0' && <span>{player.position}</span>}
        </h3>
        <h3>
          <span>{leagueSummary}</span>
          <span>{teamSummary}</span>
          <span>
            {career.season.start_year}
            {career.season.start_year !== career.season.end_year &&
              ` - ${career.season.end_year}`}
          </span>
        </h3>
      </div>
    </div>
  );
};

PlayerViewSummary.propTypes = {
  player: PropTypes.object.isRequired,
};

export default PlayerViewSummary;
